import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/Blog.css";
import { updateMetaTags, generateBreadcrumbSchema } from "../lib/seo";

const _imagesContext = require.context(
  "../assets",
  false,
  /\.(png|jpe?g|webp|svg)$/
);
const _images = _imagesContext.keys().reduce((acc, p) => {
  const key = p.replace("./", "");
  acc[key] = _imagesContext(p);
  return acc;
}, {});

const postsContext = require.context("../content/posts", false, /\.json$/);
const allPosts = postsContext.keys().map((key) => postsContext(key));

function resolveImage(path) {
  if (!path) return null;
  if (path.startsWith("/") || path.startsWith("http")) return path;
  const m = path.match(/assets\/(.+)$/);
  const name = m ? m[1] : null;
  if (name && _images[name]) return _images[name];
  return path.replace(/^\.\./, "");
}

const Blog = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    // SEO Optimization
    updateMetaTags({
      title: "Blog | Astrološki Nasveti in Člangki - Astrologija v Vortexu",
      description:
        "Odkrijte astrološke nasvete, interpretacije in vpoglede v natalne karte, sinastrijo in horoskope. Brezplačni članki o astrologiji za osebno rast.",
      keywords:
        "astrologija blog, astrološki nasveti, natalna karta razlaga, sinastrija članki, horoskop napovedi, astrološka interpretacija, osebna rast",
      canonical: "https://www.astrologijavortex.si/blog",
      structuredData: generateBreadcrumbSchema([
        { name: "Domov", url: "https://www.astrologijavortex.si/" },
        { name: "Blog", url: "https://www.astrologijavortex.si/blog" },
      ]),
    });

    const sortedPosts = [...allPosts].sort(
      (a, b) => new Date(b.date) - new Date(a.date)
    );
    setPosts(sortedPosts);
  }, []);

  return (
    <div className="blog-page" itemScope itemType="https://schema.org/Blog">
      <h1 className="page-title" itemProp="name">
        Blog
      </h1>
      <p className="intro-text" itemProp="description">
        Na blogu delimo novice, astrološke nasvete in razmišljanja. Objave lahko
        urejate na strani za administracijo.
      </p>
      <div className="posts-list">
        {posts.length === 0 && <p>Trenutno ni objav.</p>}
        <div className="posts-grid" role="list" aria-label="Seznam člankov">
          {posts.map((post, idx) => (
            <article
              key={post.id}
              itemScope
              itemType="https://schema.org/BlogPosting"
              role="listitem"
              className="post-card card fade-in"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              {post.image && (
                <div className="post-image-wrap">
                  <img
                    src={resolveImage(post.image)}
                    alt={`Slika za članek: ${post.title}`}
                    loading="lazy"
                    itemProp="image"
                    width="400"
                    height="250"
                  />
                </div>
              )}
              <div className="post-card-body">
                <h2 className="post-title" itemProp="headline">
                  {post.title}
                </h2>
                <div className="post-meta">
                  <time dateTime={post.date} itemProp="datePublished">
                    {post.date}
                  </time>
                  {post.author && (
                    <span
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      {" "}
                      • <span itemProp="name">{post.author}</span>
                    </span>
                  )}
                </div>
                <p className="post-excerpt">{post.excerpt}</p>
                <Link className="button primary" to={`/blog/${post.id}`}>
                  Preberi več
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
